import ReactGA from "react-ga4";

const GoogleAnalytics = () => {
  ReactGA.initialize("G-LVKSK2K992");  // Use your tracking ID here
  
  ReactGA.send("pageview");  // Sends the pageview on load
  
  return null; // This component doesn’t render anything
};

export default GoogleAnalytics;
